import styled from '@emotion/styled';
import { Swatches, ThemeLight } from '../base/variables';
import { Variables } from '../base';

export const AvatarStackContainer = styled.div`
    display: inline-flex;
    position: relative;
    height: 32px;
    vertical-align: middle;
`;

export const AvatarWrapper = styled.div<{ index: number; avatarSize?: number; step?: number }>`
    position: absolute;
    left: ${props => (props.step !== undefined ? props.index * props.step : props.index * 17)}px;
    width: ${props => props.avatarSize ?? 32}px;
    height: ${props => props.avatarSize ?? 32}px;
    z-index: ${props => props.index};
`;

export const MessagingAvatarStackContainer = styled.div`
    display: inline-flex;
    position: relative;
    height: 24px;
    vertical-align: middle;
`;

export const MessagingAvatarWrapper = styled.div<{ index: number; avatarSize: number; step: number }>`
    position: absolute;
    left: ${props => props.index * props.step}px;
    width: ${props => props.avatarSize}px;
    height: ${props => props.avatarSize}px;
    z-index: ${props => props.index};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Avatar = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 9999px;
    background: ${ThemeLight.PrimaryInverted9};
    border: 2px solid ${Swatches.White};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${ThemeLight.PrimaryInverted2};
    font-size: 12px;
    cursor: default;
`;
export const MessagingAvatar = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    width: 24px;
    padding: 2px 8px;
    font-size: 14px;
    border: 2px solid ${Swatches.White};
    font-weight: ${Variables.FontWeight.regular};
    color: ${Variables.ThemeLight.PrimaryInverted2};
    background-color: ${Variables.ThemeLight.PrimaryInverted9};
    border-radius: 9999px;
    line-height: 1;

    &:hover {
        background-color: ${Variables.ThemeLight.PrimaryInverted8};
    }
`;
export const EmptyState = styled.span`
    color: ${Swatches.Gray7};
    font-style: italic;
    font-size: 12px;
`;

